import { AppConfig } from '@core/domain/AppConfig.ts';
import { OFFLINE_SW_UPDATE_PENDING_SESSION_KEY } from '@core/domain/offlineServiceWorkerUpdateEvents.ts';
import { resolveSnapshotRevisionLsKey } from '@src/modules/shared/local-sqlite/infrastructure/snapshotRevisionGuard.ts';

const MASTER_CATALOG_REVISION_KEY = 'bono_master_catalog_revision';
const OFFLINE_SYNC_LAST_OK_KEY = 'bono_offline_sync_last_ok';
const OPEN_SYNC_UPDATE_TAB_SESSION_KEY = 'bono_open_sync_update_tab';

/** Removes app-specific sessionStorage keys (sync UI, transient state). */
export function clearAppSessionStorageKeys(): void {
  try {
    const ss = globalThis.sessionStorage;
    if (ss === undefined) return;
    ss.removeItem(OFFLINE_SYNC_LAST_OK_KEY);
    ss.removeItem(OFFLINE_SW_UPDATE_PENDING_SESSION_KEY);
    ss.removeItem(OPEN_SYNC_UPDATE_TAB_SESSION_KEY);
  } catch {
    /* ignore */
  }
}

/** Removes snapshot revision, catalog revision and upgrade flags from localStorage. */
export function clearAppMaintenanceLocalStorageKeys(): void {
  const lsKey = resolveSnapshotRevisionLsKey(import.meta.env);
  const upgradePendingKey = `${lsKey}:catalog_refresh_pending`;
  try {
    const ls = globalThis.localStorage;
    if (ls === undefined) return;
    ls.removeItem(lsKey);
    ls.removeItem(upgradePendingKey);
    ls.removeItem(MASTER_CATALOG_REVISION_KEY);
  } catch {
    /* ignore */
  }
}

/** Clears JWT from both localStorage and legacy sessionStorage slot. */
export function clearAuthTokenFromBrowserStorage(): void {
  const key = AppConfig.getTokenKey();
  try {
    globalThis.localStorage?.removeItem(key);
    globalThis.sessionStorage?.removeItem(key);
  } catch {
    /* ignore */
  }
}
